import { useCallback, useEffect, useState } from "react";

import { getServiceOrders } from "services/serviceOrders/rest";
import { ServiceOrderDto } from "services/serviceOrders/restModels";

export interface UseServiceOrdersResult {
    orders: ServiceOrderDto[];
    total: number;
    loading: boolean;
    error: boolean;
    refetch: () => void;
}

// Пагинация серверная (skip/limit, как во всех списках проекта): окно держит вызывающая
// фича, хук тянет его и общее количество записей.
export const useServiceOrders = (skip: number, limit: number): UseServiceOrdersResult => {
    const [orders, setOrders] = useState<ServiceOrderDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: ответ после размонтирования (или смены страницы) не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        getServiceOrders(skip, limit)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setOrders(result.items);
                    setTotal(result.total);
                } else {
                    setError(true);
                    setOrders([]);
                    setTotal(0);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setOrders([]);
                setTotal(0);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [skip, limit, reloadKey]);

    return { orders, total, loading, error, refetch };
};
